// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VideoReferenceNode 样式 */
.VideoReferenceNode-wrapper {
  width: 280px;
}

.VideoReferenceNode-error {
  padding: 8px 12px;
  margin-bottom: 8px;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  font-size: 12px;
  color: #c33;
}

.VideoReferenceNode-preview {
  position: relative;
}

.VideoReferenceNode-video {
  width: 100%;
  border-radius: 8px;
  display: block;
  border: 1px solid #ddd;
  background: #000;
  max-height: 280px;
}

.VideoReferenceNode-clear {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 6px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  line-height: 1;
  z-index: 1;
}

.VideoReferenceNode-clear:hover {
  background: rgba(0, 0, 0, 0.8);
}

.VideoReferenceNode-info {
  margin-top: 8px;
}

.VideoReferenceNode-upload-status {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #f0f4ff;
  border-radius: 6px;
  font-size: 12px;
  color: #667eea;
  margin-bottom: 6px;
}

.VideoReferenceNode-loading-small {
  width: 14px;
  height: 14px;
  border: 2px solid #e0e0e0;
  border-top: 2px solid #667eea;
  border-radius: 50%;
  animation: VideoReferenceNode-spin 1s linear infinite;
}

.VideoReferenceNode-filename {
  font-size: 11px;
  color: #666;
  word-break: break-all;
  padding: 4px 0;
}

.VideoReferenceNode-warning {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  font-size: 11px;
  color: #856404;
  margin-top: 4px;
}

.VideoReferenceNode-dropzone {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 32px 16px;
  text-align: center;
  cursor: pointer;
  background: white;
  transition: all 0.2s;
}

.VideoReferenceNode-dropzone:hover {
  border-color: #667eea;
  background: #f9faff;
}

.VideoReferenceNode-dropzone-active {
  border-color: #667eea;
  background: #f0f4ff;
}

.VideoReferenceNode-dropzone-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.VideoReferenceNode-icon {
  color: #999;
}

.VideoReferenceNode-text {
  font-size: 13px;
  color: #666;
}

.VideoReferenceNode-hint {
  font-size: 11px;
  color: #999;
}

.VideoReferenceNode-loading {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: VideoReferenceNode-spin 1s linear infinite;
}

@keyframes VideoReferenceNode-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/VideoReferenceNode.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":["/* VideoReferenceNode 样式 */\n.VideoReferenceNode-wrapper {\n  width: 280px;\n}\n\n.VideoReferenceNode-error {\n  padding: 8px 12px;\n  margin-bottom: 8px;\n  background: #fee;\n  border: 1px solid #fcc;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #c33;\n}\n\n.VideoReferenceNode-preview {\n  position: relative;\n}\n\n.VideoReferenceNode-video {\n  width: 100%;\n  border-radius: 8px;\n  display: block;\n  border: 1px solid #ddd;\n  background: #000;\n  max-height: 280px;\n}\n\n.VideoReferenceNode-clear {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  padding: 6px;\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 20px;\n  line-height: 1;\n  z-index: 1;\n}\n\n.VideoReferenceNode-clear:hover {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.VideoReferenceNode-info {\n  margin-top: 8px;\n}\n\n.VideoReferenceNode-upload-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  background: #f0f4ff;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #667eea;\n  margin-bottom: 6px;\n}\n\n.VideoReferenceNode-loading-small {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #e0e0e0;\n  border-top: 2px solid #667eea;\n  border-radius: 50%;\n  animation: VideoReferenceNode-spin 1s linear infinite;\n}\n\n.VideoReferenceNode-filename {\n  font-size: 11px;\n  color: #666;\n  word-break: break-all;\n  padding: 4px 0;\n}\n\n.VideoReferenceNode-warning {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 4px;\n  font-size: 11px;\n  color: #856404;\n  margin-top: 4px;\n}\n\n.VideoReferenceNode-dropzone {\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  padding: 32px 16px;\n  text-align: center;\n  cursor: pointer;\n  background: white;\n  transition: all 0.2s;\n}\n\n.VideoReferenceNode-dropzone:hover {\n  border-color: #667eea;\n  background: #f9faff;\n}\n\n.VideoReferenceNode-dropzone-active {\n  border-color: #667eea;\n  background: #f0f4ff;\n}\n\n.VideoReferenceNode-dropzone-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.VideoReferenceNode-icon {\n  color: #999;\n}\n\n.VideoReferenceNode-text {\n  font-size: 13px;\n  color: #666;\n}\n\n.VideoReferenceNode-hint {\n  font-size: 11px;\n  color: #999;\n}\n\n.VideoReferenceNode-loading {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #667eea;\n  border-radius: 50%;\n  animation: VideoReferenceNode-spin 1s linear infinite;\n}\n\n@keyframes VideoReferenceNode-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
